<template>
    <div :class="{hidden: !(loading && !formData.auth_type) }">
        <loading></loading>
    </div>
    <div :class="{hidden: loading && !formData.auth_type}">
        <form  action="" class="form" @submit.prevent="loginWithou2fa" ref='form' >
            <div v-if="errors.message && !formData.auth_type" class="bg-red text-white mb-5 px-3 py-2 rounded ">
                {{ errors.message }}
            </div>
            <template v-if="step == 1">
                <div class="input-container input-container--floating relative h-12 mb-5"
                     :class="{empty: !formData.email, error: errors.email}">
                    <input
                            id="email"
                            type="email"
                            v-model="formData.email"
                            class="h-full w-full border-gray-300 px-2 transition-all border-blue-gray rounded text-blue "
                    />
                    <label for="email" class="absolute left-2 transition-all px-1 text-blue-gray ">
                        Email
                    </label>
                </div>

                <div class="input-container input-container--floating relative h-12 mb-5 "
                     :class="{empty: !formData.password, error: errors.password}">
                    <input
                            id="password"
                            type="password"
                            v-model="formData.password"
                            class="h-full w-full border-gray-300 px-2 transition-all border-blue-gray rounded text-blue"
                            autocomplete="on"
                    />
                    <label for="password" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Password
                    </label>
                </div>
                <div class="mt-10 flex items-center ">
                    <button type="submit" class="btn ">Login</button>
                    <router-link
                            :to="{ name: 'requestAccess' }"
                            class="ml-4 btn btn--gray-outline">Request Access</router-link>
                </div>
                <div class="mt-4">
                    <router-link
                            :to="{ name: 'forgotPassword' }"
                            class="style-body text-red hover:text-red-hover font-light underline cursor-pointer">Forgot Password?</router-link>
                </div>

            </template>
        </form>
    </div>
    <pop-up>
        <div v-if="this.tfa">
            <div class="text-white">
                <h2 class="text-2xl text-white mb-5">
                     2 Factor Authenticator
                </h2>
                <div v-if="this.tfa.type == 'google_authenticator'" >
                    <div class="text-4xl mb-5">
                        <i class="fas fa-mobile-alt mr-3"></i>
                    </div>
                    <div class="mb-5">
                        <p class="mb-1">
                            This account is protected by 2-Factor Authentication.
                        </p>
                        <p class="mb-1">
                            Please enter the code from your Authenticator App
                        </p>
                    </div>
                </div>
                <div v-if="this.tfa.type == 'email'" >
                    <div class="text-4xl mb-5">
                        <i class="fas fa-envelope mr-3"></i>
                    </div>
                    <div class="mb-5">
                        <p class="mb-1">
                            This account is protected by 2-Factor Authentication.
                        </p>
                        <p class="mb-1">
                            We've sent you an email with a one-time Verification Code, please enter it below
                        </p>
                    </div>
                </div>

                <div class="flex">
                    <div class="input-container input-container--floating relative md:w-64 "
                         :class="{empty: !formData.code, error: errors.code}">
                        <input
                                id="code"
                                type="number"
                                v-model="formData.code"
                                @keyup.enter="verify"
                                class="h-full w-full border-gray-300 px-2 transition-all border-blue-gray rounded text-blue "
                        />
                        <label for="code" class="absolute left-2 transition-all px-1 text-blue-gray ">
                            Code
                        </label>

                        <span class="absolute flex items-center text-2xl" :class="{hidden: !loading }" style="right: 9px;top: calc(50% - 10px);">
                            <i class="fas fa-spinner fa-spin text-black"></i>
                        </span>
                    </div>

                    <button type="submit" class="btn ml-4" @click="verify" >Verify</button>
                </div>

                <div class="flex mt-2">
                    <span v-if="this.tfa.type == 'email'" type="submit" class="text-gray-100 underline cursor-pointer" @click="resend" >Resend Code</span>
                </div>

                <div v-if="(errors.message) && formData.auth_type" class="mt-5 bg-red text-white mb-5 px-3 py-2 rounded ">
                    {{ errors.message }}
                </div>

                <div class="mt-5" v-if="this.tfa.type == 'google_authenticator'">
                    Lose your phone?  <span
                                        @click="switchToMail"
                                        class="inline-block text-red hover:text-red-hover font-light underline cursor-pointer ">Email My Code</span>
                </div>
            </div>


        </div>
    </pop-up>
</template>


<script charset="utf-8">
    import Vuex from 'vuex';
    import moment from 'moment';
    import Loading from '../includes/Loading.vue';
    import PopUp from '../includes/PopUp.vue';
    import Auth from "../../model/auth";

    export default {
        data() {
            return {
                openPopup: true,
                step: 1,
                tfa: null,
                loading: false,
                user: null,
                formData: {
                    email: "",
                    password: "",
                    remember: true,
                    code: "",
                    staySignedIn: false,
                    auth_type: "",
                },
                errors: {}
            }
        },

        components: {
            Loading,
            PopUp
        },

        created: function(){
            this.setShowPopUp(false);
        },

        computed: {
            ...Vuex.mapGetters('layout', {
                showPopUp: 'showPopUp'
            }),
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
        },

        methods: {
            ...Vuex.mapMutations('layout', {
                setShowPopUp: 'setShowPopUp'
            }),

            ...Vuex.mapMutations('profile', {
                setProfile: 'setProfile'
            }),

            ...Vuex.mapActions('profile', {
                login: 'login'
            }),
            switchToMail(){
                if(this.user.tfas.email){
                    this.tfa = this.user.tfas.email;
                    this.formData.auth_type = this.tfa.type;
                    this.doLogin();
                }
            },
            loginWithou2fa(){
                this.formData.auth_type = '';
                this.formData.code = '';
                this.tfa = null;
                this.doLogin();
            },
            resend(){
                this.auth_type = '';
                this.formData.code = '';
                this.doLogin();
            },
            verify(){
                if(this.formData.code){
                    this.doLogin();
                }
            },
            doLogin() {
                this.loading = true;
                this.login(this.formData)
                    .then((res) => {
                        this.loading = false;
                        this.errors = {}

                        this.user = res;

                        // check status first
                        if(this.user.status != 'active'){
                            this.errors = {
                                message: 'Account has been deactivated',
                            };
                            return;
                        }

                        if(this.user.locked_until){
                            this.errors = {
                                message: 'Account is locked until ' + moment(this.user.locked_until * 1000).format('LT')  ,
                            };
                            return;
                        }
                        // check tfa
                        if(!this.tfa){
                            if (this.user.tfas) {
                                if(this.user.tfas.google_authenticator){
                                    this.tfa = this.user.tfas.google_authenticator;
                                    this.formData.auth_type = this.tfa.type;
                                }else{
                                    this.tfa = this.user.tfas.email;
                                    this.formData.auth_type = this.tfa.type;
                                }
                                this.setShowPopUp(true);

                            }
                        }

                        // check if has auth token
                        if(!this.user.authtoken){
                            return;
                        }

                        // yayyyyy, you are in
                        this.setProfile(new Auth(this.user));

                        this.setShowPopUp(false);

                        if(this.profile.isUser() || this.profile.isManager()){
                            this.$router.push({
                                name: 'dashboard'
                            });
                        }

                        if(this.profile.isGroupAdmin()){
                            this.$router.push({
                                name: 'groupAdminClients'
                            });
                        }

                        if(this.profile.isSharpAdmin()){
                            this.$router.push({
                                name: 'adminClients'
                            });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        if(this.formData.auth_type){
                            this.errors = {
                                message: '2 Factor Authenticator code is incorrect match'
                            }
                        }else{
                            this.errors = {
                                message: 'The provided credentials do not match'
                            }
                        }

                    })
            }
        },
    }
</script>
